export enum AnimationTypes {
    MOVE = 'MOVE',
    ROTATE = 'ROTATE',
    SCALE = 'SCALE',
    BLINK = 'BLINK',
    POP = 'POP',
    CORNER_PIN = 'CORNER_PIN',
    DATA_IMPORT = 'DATA_IMPORT',
}
